export const unaccent = (accent: string) : string => {
    // Remove accents from string, \u0300-\u036f unicode plage for accents
    return accent.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const isValidJSON = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch {
    return false;
  }
};